import { render } from "./SearchStaticPage.vue?vue&type=template&id=0b8cf67d"
import script from "./SearchStaticPage.vue?vue&type=script&lang=js"
export * from "./SearchStaticPage.vue?vue&type=script&lang=js"

import "./SearchStaticPage.vue?vue&type=style&index=0&id=0b8cf67d&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__